export enum Delivery_Status {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

const openAILogo =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQS3PwERLLNB9XKFpeMgAMPxl5VvN3HRJnXQQ&s";
export const AI_SUPPORT = {
  DALL_E_3: {
    name: "DALL-E 3",
    distributor: "OpenAI",
    model: "dall-e-3",
    expectBudget: 0,
    isRead: false,
    type: "system_ai",
    description: "OpenAI generate image",
    avatar: openAILogo,
  },
  GPT_4_1: {
    name: "GPT-4.1",
    distributor: "OpenAI",
    model: "gpt-4.1",
    expectBudget: 0,
    isRead: false,
    type: "system_ai",
    description: "OpenAI generate image",
    avatar: openAILogo,
  },
};
